var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4948 1.66599H4.99792C4.55608 1.66599 4.13233 1.84151 3.8199 2.15394C3.50747 2.46637 3.33195 2.89011 3.33195 3.33196V16.6597C3.33195 17.1016 3.50747 17.5253 3.8199 17.8378C4.13233 18.1502 4.55608 18.3257 4.99792 18.3257H14.9938C15.4356 18.3257 15.8593 18.1502 16.1718 17.8378C16.4842 17.5253 16.6597 17.1016 16.6597 16.6597V5.83092L12.4948 1.66599Z",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6618 1.66599V4.99793C11.6618 5.43977 11.8373 5.86352 12.1498 6.17595C12.4622 6.48838 12.8859 6.6639 13.3278 6.6639H16.6597",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32986 7.49689H6.66389",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3278 10.8288H6.66389",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3278 14.1608H6.66389",
    stroke: "white",
    strokeWidth: 1.66597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.3924165b2f85bd7a67c259728ef2acc7.svg";
export { ForwardRef as ReactComponent };